import Moment from 'moment'

// API datetime: UTC without zone marker, e.g. "2021-11-22T14:10:27.323365"
const API_DATETIME = /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?$/

/**
 * Same result as Moment.utc(datetime).local(), ~8x faster for the API datetime format
 * (moment's string parsing was ~0.25s on big task lists). Other formats go through moment.
 *
 * Gotcha: out-of-range parts (month 13, day 32) roll over instead of giving an invalid moment -
 * the regex only checks the shape, the API never sends such values
 */
export default function utcDatetimeToMoment(datetime: string): Moment.Moment {
    const match = API_DATETIME.exec(datetime)

    if (!match) {
        return Moment.utc(datetime).local()
    }

    // same fraction -> ms conversion as moment (truncates microseconds)
    const ms = match[7] ? Math.floor(Number('0.' + match[7]) * 1000) : 0

    return Moment(Date.UTC(
        Number(match[1]),
        Number(match[2]) - 1,
        Number(match[3]),
        Number(match[4]),
        Number(match[5]),
        Number(match[6]),
        ms
    ))
}
